<template>
    <div id="features-container">
        <FeatureItem
                v-for="(feature, index) in features"
                :key="index"
                :index="index"
                :title="feature.title"
                :description="feature.description"
                :image-path="feature.imagePath"
                :go-to-reference="feature.goToRef"
                :alt-desc="feature.altDesc"
        />
    </div>
</template>


<script>
    import FeatureItem from "./sub-components/FeatureItem";

    export default {
        name: 'Template',

        props: {
        },

        mounted() {
        },

        components: {
            FeatureItem
        },

        methods: {

        },

        data: () => ({
            features:  [
                {
                    title: "Dark Pool & Block Trades",
                    description: "See large Dark Pool and Blocks throughout the day",
                    imagePath: '/assets/darkpoolprem.png',
                    goToRef: "dpandblocks",
                    altDesc: "OptionsFamBot Flow Command"
                },
                {
                    title: "Crypto Stream",
                    description: "See large Crypto Block Trades throughout the day",
                    imagePath: '/assets/cryptoofb.png',
                    goToRef: "cryptoofb",
                    altDesc: "OptionsFamBot Crypto Command"
                },
                {
                    title: "Detailed Breakouts",
                    description: "Plot Dark Pool prints on the chart and see all the daily flow / block trades in one view",
                    imagePath: '/assets/chartingprem.png',
                    goToRef: "breakout",
                    altDesc: "OptionsFamBot Dark Pool Command"
                },
                {
                    title: "Short Volume",
                    description: "Get the latest Short Volume data per Finra",
                    imagePath: '/assets/ShortVolprem.png',
                    goToRef: "shortvol",
                    altDesc: "OptionsFamBot Dark Pool Command"
                },
                {
                    title: "Open Interest",
                    description: "Open Interest data broken down by expiration",
                    imagePath: '/assets/OIprem.png',
                    goToRef: "oidata",
                    altDesc: "OptionsFamBot Options Command"
                },

                {
                    title: "Institutional Change Data",
                    description: "See the Institutional breakout by most holding percent change",
                    imagePath: '/assets/instChangePrem.png',
                    goToRef: "instdata",
                    altDesc: "OptionsFamBot Futures Command"
                },
                {
                    title: "Company Details",
                    description: "See detailed company info for each stock",
                    imagePath: '/assets/Detailsprem.png',
                    goToRef: "details",
                    altDesc: "OptionsFamBot Charting Command"
                },
            ]
        }),
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #features-container{
        width: 100%;
        max-width: 1400px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

</style>
